import { Controller } from '@hotwired/stimulus'
class SearchFormController extends Controller {
  connect () { }

  submit (e) {
    e.preventDefault()
    const params = new URLSearchParams(window.location.search)
    this.element.querySelectorAll('input').forEach(el => {
      params.set(el.name, el.value)
    })
    window.location.search = params
  }
}

class ToggleController extends Controller {
  toggleControl (event) {
    event.target.closest('form').requestSubmit()
  }
}

class TextSearchController extends Controller {
  connect () {
    this.init()
  }

  init () {
    const params = new URLSearchParams(window.location.search)
    if (params.has(this.element.name)) { this.element.value = params.get(this.element.name) }
  }
}

export { ToggleController, TextSearchController, SearchFormController }
